// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.video[data-v-3aa379e6] {\n  border-radius: 10px;\n}\n", ""]);
// Exports
module.exports = exports;
